<template>
	<ul class="home-timeline">
		<home-timeline-item v-for="(item,index) in fonum" :spl="spl" :key="index" :isacolor="isacolor"></home-timeline-item>
	</ul>
</template>
<script>
import homeTimelineItem from './homeTimelineItem'
	export default {
		name: 'lvTimeline',
		props: {
			fonum: Number,
			spl: Number,
			isacolor:Boolean,
		},
		components:{
			homeTimelineItem
		}
	};
</script>

